import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TYPE_TARIFF_SHEET_CLIENT_INTEREST } from '@app/@core/constants/tariffSheet.constants';
import { CustomerInterestResponse, TariffSheetRequest, TermFeeSheetTarTwo } from '../model/tariffs-model';
import { TariffsStore } from '../services/tariffs.store';
import jsPDF from 'jspdf';
import autoTable, { Table } from 'jspdf-autotable';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { DatePipe } from '@angular/common';
import FileSaver from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-interest',
  templateUrl: './interest.component.html',
  styleUrls: ['./interest.component.scss'],
})
export class InterestComponent implements OnInit {
  tariffSheetRequest: TariffSheetRequest;
  customerInterestResponse: CustomerInterestResponse;
  dataSource = new MatTableDataSource<TermFeeSheetTarTwo>();

  isDataObtainedEmpty: boolean = false;

  public displayedColumns = ['terms', 'coefficient', 'tin', 'fee', 'discount'];

  private head = [
    'tariffs.interest.term',
    'tariffs.interest.coefficient',
    'tariffs.interest.tin',
    'tariffs.interest.fee',
    'tariffs.discount.discount',
  ];

  constructor(
    private tariffsStore: TariffsStore,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {}

  getInterestCommerceTariff(tariffSheetRequest: TariffSheetRequest) {
    this.isDataObtainedEmpty = false;
    this.tariffSheetRequest = tariffSheetRequest;
    this.tariffSheetRequest.typeTariffSheet = TYPE_TARIFF_SHEET_CLIENT_INTEREST;
    this.tariffsStore
      .getCommercialInterest(this.tariffSheetRequest)
      .then((data) => {
        if (data) {
          this.customerInterestResponse = data;
          this.dataSource.data = this.customerInterestResponse.tariffSheetTarTwoDTO.tariff;
        } else {
          this.isDataObtainedEmpty = true;
        }
      })
      .catch((error) => {
        console.error(error);
        this.isDataObtainedEmpty = true;
      });
  }

  createPdf() {
    try {
      let doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [209, 296],
      });
      const date = new Date();
      const dateFormat = moment().locale('es').format('DDMMYYYY');
      const filename = this.translateService.instant('tariffs.interest.excel.title') + dateFormat;

      doc.setProperties({
        title: filename,
      });

      const dataPdf: any[] = [];
      /* BODY */
      this.dataSource.data.forEach((item) => {
        const dataPdfOrder = JSON.stringify(item, ['termCon', 'coefCon', 'strTinT', 'porapeCon', 'imdees']);
        const ObjectDataPdf = JSON.parse(dataPdfOrder);
        dataPdf.push(ObjectDataPdf);
      });

      const tableWidth = 180;
      const startTable = 55;
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const margin = (pageWidth - tableWidth) / 2;

      const cellWidth = 180 / 5;

      var lastHeight = 0;

      autoTable(doc, {
        startY: startTable,
        tableWidth: 150,
        pageBreak: 'auto',
        rowPageBreak: 'avoid',
        showHead: 'everyPage',
        margin: { left: margin, right: margin, top: startTable },
        head: [this.head.map((header) => this.translateService.instant(header))],
        headStyles: { fillColor: '#969696', halign: 'center', valign: 'middle' },
        body: dataPdf.map(Object.values),
        bodyStyles: {
          cellWidth: cellWidth,
          halign: 'center',
          valign: 'middle',
          cellPadding: { horizontal: 4, vertical: 1 },
        },
        columnStyles: {},
        didDrawCell: (data) => {
          const cell = data.cell;
          const width = cell.width;
          const height = cell.height;
          doc.rect(cell.x, cell.y, width, height);

          lastHeight = cell.y;
        },
        didDrawPage: (data) => {
          /* HEADER */
          doc.setFontSize(10);
          doc.text(this.datePipe.transform(new Date(), 'MMM d, y, h:mm:ss'), 150, 20);

          var img = new Image();
          img.src = 'assets/img/logo.PNG';
          doc.addImage(img, 'png', 3, 4, 65, 22);

          /* HEADER */
          const margin = 14;
          const titleFontSize = 14;
          const titleRectangleHeight = 8;
          const titleRectanglePosY = 25;

          doc.setFontSize(titleFontSize);
          doc.setFont(undefined, 'bold');

          doc.setDrawColor(0);
          doc.setTextColor('#FFFFFF');
          doc.setFillColor('#969696');

          doc.rect(margin, titleRectanglePosY, pageWidth - 28, titleRectangleHeight, 'F');
          doc.text(
            this.tariffSheetRequest.commercialProduct.value + ' ' + this.tariffSheetRequest.establishment.value,
            pageWidth / 2,
            titleRectanglePosY + 6,
            { align: 'center' }
          );

          doc.setFontSize(12);
          doc.setFont(undefined, 'italic');

          doc.setDrawColor(0);
          doc.setTextColor('#FFFFFF');
          doc.setFillColor('#969696');

          doc.rect(margin, titleRectanglePosY + titleRectangleHeight + 2, pageWidth - 28, titleRectangleHeight, 'F');
          doc.text(
            this.translateService.instant('tariffs.header'),
            pageWidth / 2,
            titleRectanglePosY + titleRectangleHeight + 8,
            { align: 'center' }
          );

          doc.setFont(undefined, 'normal');
          doc.setTextColor('#0000EE');

          doc.text(
            'www.sabadellconsumer.com',
            pageWidth / 2,
            titleRectanglePosY + titleRectangleHeight + 2 + titleRectangleHeight + 5,
            { align: 'center' },
            { url: 'https://www.sabadellconsumer.com/' }
          );

          doc.setFontSize(8);
          doc.setFont(undefined, 'bold');

          doc.setDrawColor(0);
          doc.setTextColor('#FFFFFF');
          doc.setFillColor('#969696');
          doc.rect(
            margin,
            titleRectanglePosY + titleRectangleHeight + 2 + 8 + 5 + 1,
            pageWidth - 28,
            titleRectangleHeight - 3,
            'F'
          );
          doc.text(
            this.tariffSheetRequest.tariffs[0].code + ' - ' + this.tariffSheetRequest.tariffs[0].description,
            margin + 1,
            titleRectanglePosY + titleRectangleHeight + 2 + 8 + 5 + 4
          );

          doc.setFont(undefined, 'normal');
          doc.setTextColor('#000000');
        },
      });

      /* FOOTER */
      //Properties
      const marginFooter = 14;
      doc.setFontSize(8);
      console.log(lastHeight, pageHeight - 53);
      //el 5 es por dejar un margen de seguridad
      if (lastHeight > pageHeight - (28 + 25 + 5)) {
        doc.addPage();
      }
      doc.rect(marginFooter, pageHeight - (28 + 25), pageWidth - 28, 25);
      doc.text(
        this.translateService.instant('tariffs.commission.short.footer'),
        marginFooter + 1,
        pageHeight - (28 + 25) + 6
      );
      doc.text(
        this.translateService.instant('tariffs.coefficient.footer'),
        marginFooter + 1,
        pageHeight - (28 + 25) + 6 * 2
      );
      doc.text(
        this.translateService.instant('tariffs.minCapital.footer'),
        marginFooter + 1,
        pageHeight - (28 + 25) + 6 * 3 + 4
      );

      doc.setFont(undefined, 'bold');
      doc.setTextColor('#FFFFFF');
      doc.setFillColor('#969696');
      doc.rect(marginFooter, pageHeight - (14 + 10), pageWidth - 28, 10, 'F');
      const phone = this.customerInterestResponse.userDataTariffDTO[0].phone;
      doc.text(
        this.translateService.instant('excel.contactPerson') +
          ' ' +
          this.customerInterestResponse.userDataTariffDTO[0].socialReason +
          ' ' +
          this.translateService.instant('excel.phone') +
          phone?.substring(0, 3) +
          ' ' +
          phone?.substring(3, 6) +
          ' ' +
          phone?.substring(6, 9) +
          ' ' +
          this.translateService.instant('excel.mail') +
          this.customerInterestResponse.userDataTariffDTO[0].email?.toUpperCase(),
        tableWidth - 56,
        pageHeight - (14 + 10) + 6,
        { align: 'center' }
      );

      var blob = doc.output('blob');
      FileSaver.saveAs(blob, filename);
      window.open(URL.createObjectURL(blob));
    } catch (error) {
      console.error(error);
    }
  }

  createExcel() {
    const title = this.tariffSheetRequest.commercialProduct.value + ' ' + this.tariffSheetRequest.establishment.value;
    const subtitle = this.translateService.instant('tariffs.header');

    const dataTable = this.dataSource.data?.map((item) => [
      item.termCon,
      item.coefCon,
      item?.strTinT,
      item.porapeCon,
      item?.imdees,
    ]);
    const phone = this.customerInterestResponse.userDataTariffDTO[0].phone;
    const contact =
      this.translateService.instant('excel.contactPerson') +
      ' ' +
      this.customerInterestResponse.userDataTariffDTO[0].socialReason +
      this.translateService.instant('excel.phone') +
      ' ' +
      phone?.substring(0, 3) +
      ' ' +
      phone?.substring(3, 6) +
      ' ' +
      phone?.substring(6, 9) +
      this.translateService.instant('excel.mail') +
      ' ' +
      this.customerInterestResponse.userDataTariffDTO[0].email?.toUpperCase();
    const tariff = this.tariffSheetRequest.tariffs[0].code + ' - ' + this.tariffSheetRequest.tariffs[0].description;
    const date = new Date();
    const dateFormat = moment().locale('es').format('DDMMYYYY');
    const filename = this.translateService.instant('tariffs.interest.excel.title') + dateFormat;

    const excelData = {
      fileName: filename,
      title: title,
      subtitle: subtitle,
      tableHeaders: this.head.map((header) => this.translateService.instant(header)),
      tableBody: dataTable,
      description:
        '\n \n' +
        this.translateService.instant('tariffs.commission.short.footer') +
        ' \n' +
        this.translateService.instant('tariffs.coefficient.footer') +
        ' \n \n' +
        this.translateService.instant('tariffs.minCapital.footer'),
      contact: contact,
      tariff: tariff,
    };

    this.excelService.exportExcelTariffSheetInterest(excelData);
  }
}
